export const getLoanDetails = loanDetails => {
  return {
    type: "GET_LOAN",
    loanDetails
  };
};

export const loanLoaded = loanDetails => {
  return {
    type: "LOAN_LOADED",
    payload: loanDetails
  };
};

export const clearLoanDetails = () => {
  return {
    type: "CLEAR_LOAN"
  };
};



// WEBPACK FOOTER //
// ./src/actions/loans.actions.js